import { useState } from 'react';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Button, MenuItem, Select, Stack, Typography } from '@mui/material';

import { settingPopOpenAtom } from '@/components/setting/users/ProfileSectionCard';
import { buttonBaseStyle } from '@/styles/constant';
import { tempUnitAtom } from '@/interfaces/utils';

import type { SelectChangeEvent } from '@mui/material';

interface PopupSetTempUnitProps {
  currentUnit: 'CELSIUS' | 'FAHRENHEIT';
}

export default function PopupSetTempUnit({ currentUnit }: PopupSetTempUnitProps) {
  const setTempUnit = useSetAtom(tempUnitAtom);
  const setOpenTarget = useSetAtom(settingPopOpenAtom);

  const [unit, setUnit] = useState<'CELSIUS' | 'FAHRENHEIT'>(currentUnit);
  const { t } = useTranslation();

  function onSelectChange(e: SelectChangeEvent) {
    setUnit(e.target.value as 'CELSIUS' | 'FAHRENHEIT');
  }
  function onCloseClick() {
    setTempUnit(unit);
    setOpenTarget({ open: '' });
  }

  return (
    <Stack sx={{ p: 3 }}>
      <Select id="Language" fullWidth={true} value={unit} onChange={onSelectChange}>
        <MenuItem value="CELSIUS">℃</MenuItem>
        <MenuItem value="FAHRENHEIT">℉</MenuItem>
      </Select>
      <Button
        variant="contained"
        color="info"
        onClick={onCloseClick}
        sx={{
          ...buttonBaseStyle,
          width: 300,
          height: 44,
          borderRadius: 22,
        }}
      >
        <Typography fontWeight="medium">{t('Common.label.registButton')}</Typography>
      </Button>
    </Stack>
  );
}
